import { Box, Paper, Stack, Typography } from '@mui/material';
import {
  CHARACTER_STRUCTURED_FIELDS,
  GROUP_LABELS,
  type CharacterFieldConfig,
} from './characterFieldConfig';
import { StructuredFieldInput } from './StructuredFieldInput';
import type { EntityDescriptorDto } from '../../api/queries/entities';

const GROUPS: CharacterFieldConfig['group'][] = [
  'identity',
  'physical',
  'personality',
  'abilities',
];

interface CharacterStructuredFieldsProps {
  entityId: string;
  descriptors: EntityDescriptorDto[];
}

export function CharacterStructuredFields({
  entityId,
  descriptors,
}: CharacterStructuredFieldsProps) {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2.5}>
        {GROUPS.map((group) => {
          const fields = CHARACTER_STRUCTURED_FIELDS.filter(
            (f) => f.group === group,
          );
          if (fields.length === 0) return null;

          return (
            <Box key={group}>
              <Typography
                variant="overline"
                color="text.secondary"
                sx={{ mb: 1, display: 'block' }}
              >
                {GROUP_LABELS[group]}
              </Typography>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                  gap: 2,
                }}
              >
                {fields.map((field) => (
                  <Box
                    key={field.category}
                    sx={{
                      gridColumn: field.colSpan === 2 ? 'span 2' : undefined,
                    }}
                  >
                    <StructuredFieldInput
                      field={field}
                      entityId={entityId}
                      descriptors={descriptors}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}
